import React, {useState} from 'react'
import './style.css'
import CardsHead from './cards_head'
import {Nav} from 'react-bootstrap'

export default function HeadCard() {
    const [dropdown, setDropdown] = useState(false)

    const onMouseEnter = _ => setDropdown(true)
    const onMouseLeave = _ => setDropdown(false)

    return (
        <Nav.Link
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        >
            <div className="nav-list">
                <div className="menu-profile">
                    <img className="head" src="asset/dashboard/icons/user.svg" alt="user" />
                    <img src="asset/dashboard/icons/menu.svg" alt="menu" />
                </div>
                </div>
                { dropdown && <CardsHead /> }
        </Nav.Link>
    )
}
